import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@clerk/react-router';

import { HiMenuAlt4, HiX } from 'react-icons/hi';
import { motion } from 'framer-motion';

import './Navbar.css';

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const navigate = useNavigate();
  const { userId } = useAuth();
  
    const handleClick= () => {
      if (userId) {
        navigate('/dashboard');
      } else {
        navigate('/login');
      }
    }

  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        {/* <img src={images.logo} alt="logo" /> */}
        <h2>Say Yes TN</h2>
      </div>
      <ul className="app__navbar-links">
        {['about', 'how', 'reviews', 'contact'].map((item) => (
          <li className="app__flex p-text" key={`link-${item}`}>
            <a href={`#${item}`}>{item}</a>
          </li>
        ))}
        <li className="app__flex p-text" key="login">
          {userId?(
            <button type="button" className="nav-buttn p-text" onClick={handleClick}>Dashboard</button>
          ):(
            <button type="button" className="nav-buttn p-text" onClick={handleClick}>Login</button>
          )}
        </li>
      </ul>

      <div className="app__navbar-menu">
        <HiMenuAlt4 onClick={() => setToggle(true)} />

        {toggle && (
          <motion.div
            whileInView={{ x: [300, 0] }}
            transition={{ duration: 0.85, ease: 'easeOut' }}
          >
            <HiX onClick={() => setToggle(false)} />
            <ul>
              {['about', 'how', 'reviews', 'contact'].map((item) => (
                <li key={item}>
                  <a href={`#${item}`} onClick={() => setToggle(false)}>
                    {item}
                  </a>
                </li>
              ))}
              <li className="app__flex p-text login-nav" key="login">
              {userId?(
                <button type="button" className="nav-buttn" onClick={handleClick}>Dashboard</button>
              ):(
                <button type="button" className="nav-buttn" onClick={handleClick}>Login</button>
              )}
              </li>
            </ul>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
